import type { Message } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types/xceed';
import { page } from '@efdigital/ll-admin-v2/data/json-api';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { findRecord, query } from '@warp-drive/utilities/json-api';

/**
 * Finds a single message by id
 * @param messageId - The id of the message
 * @returns JSON API request to find the message
 */
export function findMessage(messageId: string) {
  return findRecord<Message>(DataTypeXceed.Message, messageId, {
    ...jsonApiOptions,
  });
}

/**
 * Finds messages for a cohort by category
 * @param cohortId - The id of the cohort
 * @param category - announcement or discussion
 * @returns JSON API request to find the messages
 */
export function queryCohortMessages(
  cohortId: string,
  category: 'announcement' | 'discussion'
) {
  return query<Message>(
    DataTypeXceed.Message,
    {
      'filter[cohort.id]': cohortId,
      'filter[category]': category,
      sort: '-startDate',
      ...page({ offset: 0, limit: 100 }),
    },
    jsonApiOptions
  );
}

/**
 * Finds messages for a section by category
 * @param sectionId - The id of the section
 * @param category - announcement or discussion
 * @returns JSON API request to find the messages
 */
export function querySectionMessages(
  sectionId: string,
  category: 'announcement' | 'discussion'
) {
  return query<Message>(
    DataTypeXceed.Message,
    {
      'filter[section.id]': sectionId,
      'filter[category]': category,
      sort: '-startDate',
      ...page({ offset: 0, limit: 100 }),
    },
    jsonApiOptions
  );
}
